import {BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ProductPage } from "./pages/ProductPage";
import { HomePage } from "./pages/HomePage";
import { AboutPage } from "./pages/AboutPage";
import {NailCommissionPage} from "./pages/NailCommissionPage";

export const Navigation = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/Shop" element={<ProductPage />} />
                <Route path="/NailCommission" element={<NailCommissionPage />} />
                <Route path="/About" element={<AboutPage />} />
            </Routes>
        </Router>
    )
}